import React, { useImperativeHandle, forwardRef } from 'react';
import { Form, Input, Button, Row, Col, Space, Select } from 'antd';
import { drugNameTypes } from '../constants';
import { useTranslation } from 'react-i18next';

interface IProps {
  onQuery?: (value: any) => void;
  loading?: boolean;
}

const QueryForm = ({ onQuery, loading }: IProps, ref: any) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    if (typeof onQuery === 'function') {
      onQuery(values);
    }
  };

  const onReset = () => {
    form.resetFields();
    if (typeof onQuery === 'function') {
      onQuery({});
    }
  };

  useImperativeHandle(ref, () => ({
    resetQuery: onReset,
    submitQuery: () => form.submit(),
  }));

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
      labelCol={{ span: 6 }}
      labelAlign="left"
      autoComplete="off"
    >
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item label={t('dict.drugName')} name="drugName">
            <Input placeholder={t('ikg.input',{name:t('dict.drugName')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.drugNameType')} name="tradeOrIngredient">
            <Select
              placeholder={t('ikg.select',{name:t('dict.drugNameType')})}
              options={drugNameTypes}
              allowClear
            />
          </Form.Item>
        </Col>
       
        <Col span={8}>
          <Form.Item label={t('dict.drugRecordNo')} name="drugRecordNumber">
            <Input placeholder={t('ikg.input',{name:t('dict.drugRecordNo')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.country')} name="countryName">
            <Input placeholder={t('ikg.input',{name:t('dict.country')})} />
          </Form.Item>
        </Col>
        <Space>
          <Button onClick={onReset}>{t('ikg.reset')}</Button>
          <Button type="primary" htmlType="submit" ghost loading={loading}>
            {t('ikg.query')}
          </Button>
        </Space>
      </Row>
    </Form>
  );
};

export default forwardRef(QueryForm);
